<template>
    <div class="home">
        <div class="left_menu">
            <div class="logo">Логотип</div>
            <div class="head">Мои адреса</div>
            <div class="streets">
                <div v-for="(s, i) in $store.getters.streets" :key="i" class="item"
                     :class="{active: streetIsActive(s.name)}">
                    <div @click="changeStreetMode(s.name)" class="name">
                        <div class="text">{{ s.name }}</div>
                        <img src="@/assets/img/down_arrow.svg" alt="">
                    </div>
                    <div v-if="streetIsActive(s.name)" class="houses_list">
                        <div @click="$store.commit('setActiveHouse', h.id)" v-for="(h, i) in s.houses" :key="i"
                             class="house_item">Дом №
                            {{ h.number }}
                        </div>
                    </div>
                </div>
            </div>
            <button class="add_house" @click="$store.commit('changeShowModal', 'AddHouse')">
                Добавить адрес <img src="@/assets/img/plus.svg" alt="">
            </button>
        </div>

        <div class="content">
            <div class="header">
                <div class="title">Личный кабинет</div>
                <div @click="exit" class="exit">Выйти</div>
            </div>

            <div class="table_menu">
                <div @click="showMode='flats'" class="inner" :class="{active: showMode=='flats'}">Квартиры</div>
                <div @click="showMode='info'" class="inner" :class="{active: showMode=='info'}">Информация</div>
            </div>

            <div v-if="showMode == 'flats' && this.$store.getters.activeHouseID" class="flats">
                <div class="separator"></div>
                <table cellspacing="0">
                    <tr class="table_header">
                        <td class="left_td">№ квартиры</td>
                        <td>№ подъезда</td>
                        <td>Пароль активации</td>
                        <td>Статус</td>
                        <td></td>
                    </tr>
                    <tr v-for="(f, i) in $store.getters.activeHouse.flats" :key="i">
                        <td class="left_td">{{ f.number }}</td>
                        <td>{{ f.entranceNumber }}</td>
                        <td>{{ f.activationPassword }}</td>
                        <td><img src="@/assets/img/ok.svg" alt=""></td>
                        <td><img @click="deleteFlat(f.id)" class="delete_icon" src="@/assets/img/delete.svg" alt="">
                        </td>
                    </tr>
                </table>
            </div>
            <div v-else-if="showMode == 'info' && this.$store.getters.activeHouseID" class="info">
                <div class="separator"></div>
                <div class="address">
                    <div class="inner">
                        <div class="title">Область</div>
                        <div class="value">{{ $store.getters.activeHouse.region }}</div>
                    </div>
                    <div class="inner">
                        <div class="title">Город</div>
                        <div class="value">{{ $store.getters.activeHouse.city }}</div>
                    </div>
                    <div class="inner">
                        <div class="title">Улица</div>
                        <div class="value">{{ $store.getters.activeHouse.street }}</div>
                    </div>
                    <div class="inner">
                        <div class="title">Номер дома</div>
                        <div class="value">{{ $store.getters.activeHouse.houseNumber }}</div>
                    </div>
                    <img @click="deleteBuilding" src="@/assets/img/delete.svg" alt="">
                </div>
                <div class="head">Домофоны</div>

                <div class="intercoms">
                    <div v-for="(intercom, i) in $store.getters.activeHouse.intercoms"
                         class="intercom" :key="i"
                         :class="{active: intercom.active}">
                        <div class="separator"></div>
                        <div class="title">
                            <div class="left">
                                <div class="name">{{ intercom.name }}</div>
                                <img
                                    @click="$store.commit('setUpdateIntercomID', intercom.id); $store.commit('changeShowModal', 'UpdateIntercom')"
                                    src="@/assets/img/update.svg" alt="">
                                <img @click="deleteIntercom(intercom.id)" src="@/assets/img/delete.svg" alt="">
                            </div>
                            <img
                                @click="$store.commit('changeIntercomActive', {houseID: this.$store.getters.activeHouseID, index: i})"
                                class="right" src="@/assets/img/down_arrow.svg" alt="">
                        </div>
                        <div class="main_info">
                            <div class="left">
                                <div class="inner">
                                    <div class="name">Диапазон квартир</div>
                                    <div class="value">{{ intercom.flatsRanges.join(", ") }}</div>
                                </div>
                                <div class="inner">
                                    <div class="name">IP-адрес домофона</div>
                                    <div class="value">{{ intercom.ip }}</div>
                                </div>
                                <div class="inner">
                                    <div class="name">Порт HTTP</div>
                                    <div class="value">{{ intercom.port }}</div>
                                </div>
                            </div>
                            <div class="right">
                                <div class="inner">
                                    <div class="name">SIP-адрес</div>
                                    <div class="value">{{ intercom.SIPAddress }}</div>
                                </div>
                                <div class="inner">
                                    <div class="name">SIP-логин</div>
                                    <div class="value">{{ intercom.SIPLogin }}</div>
                                </div>
                                <div class="inner">
                                    <div class="name">SIP-пароль</div>
                                    <div class="value">{{ intercom.SIPPassword }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="intercom.active" class="additional_info">
                            <div class="left">
                                <div class="inner">
                                    <div class="name">IP-адрес для видео</div>
                                    <div class="value">{{ intercom.ipForVideo }}</div>
                                </div>
                                <div class="inner">
                                    <div class="name">Логин для видео</div>
                                    <div class="value">{{ intercom.loginForVideo }}</div>
                                </div>
                                <div class="inner">
                                    <div class="name">Пароль для видео</div>
                                    <div class="value">{{ intercom.passwordForVideo }}</div>
                                </div>
                                <div class="inner">
                                    <div class="name">Порт для видео</div>
                                    <div class="value">{{ intercom.portForVideo }}</div>
                                </div>
                            </div>
                            <div class="right">
                                <div class="inner">
                                    <div class="name">Логин для HTTP</div>
                                    <div class="value">{{ intercom.loginForHTTP }}</div>
                                </div>
                                <div class="inner">
                                    <div class="name">Пароль для HTTP</div>
                                    <div class="value">{{ intercom.passwordForHTTP }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button @click="$store.commit('changeShowModal', 'AddFlat')"
                    v-if="$store.getters.activeHouse && showMode == 'flats'" class="add_new new_flat">Добавить квартиру
                <img src="@/assets/img/plus.svg" alt=""></button>
            <button @click="$store.commit('changeShowModal', 'AddIntercom')"
                    v-if="$store.getters.activeHouse && showMode == 'info'" class="add_new new_intercom">Добавить
                домофон
            </button>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            activeStreets: [],
            showMode: "flats"
        }
    },
    methods: {
        async deleteBuilding() {
            this.$store.commit("setHouseForDelete", this.$store.getters.activeHouseID)
            this.$store.commit("changeShowModal", "DeleteHouse")
        },
        changeStreetMode(name) {
            for (let i = 0; i < this.activeStreets.length; i++) {
                if (this.activeStreets[i] == name) {
                    this.activeStreets.splice(i, 1)
                    return
                }
            }
            this.activeStreets.push(name)
        },
        streetIsActive(name) {
            for (let i = 0; i < this.activeStreets.length; i++) {
                if (this.activeStreets[i] == name) {
                    return true
                }
            }
            return false
        },
        exit() {
            localStorage.clear()
            this.$router.push("/auth")
        },
        async deleteFlat(id) {
            let r = await this.$store.dispatch("request", {
                method: "DELETE",
                path: `/adm/flats/${id}`
            })
            if (r.status == 200) {
                this.$store.dispatch("loadData")
            }
        },
        async deleteIntercom(id) {
            let r = await this.$store.dispatch("request", {
                method: "DELETE",
                path: `/adm/panels/${id}`
            })
            if (r.status == 200) {
                this.$store.dispatch("loadData")
            }
        },
    },
}
</script>


<style scoped lang="scss">
.home {
    height: 100vh;
    display: flex;

    .left_menu {
        background: #F2F2F2;
        width: 264px;
        height: 100%;
        padding: 40px 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .logo {
            margin-bottom: 65px;
            margin-left: 24px;
        }

        .head {
            font-weight: 700;
            font-size: 20px;
            line-height: 30px;
            color: #333333;
            margin-bottom: 28px;
            margin-left: 24px;
        }

        .streets {
            flex: 1;
            overflow-y: auto;
            margin-bottom: 20px;

            .item {
                .name {
                    background: #D6D6D6;
                    padding: 16px 34px;
                    font-size: 16px;
                    line-height: 20px;
                    display: flex;
                    justify-content: space-between;
                    cursor: pointer;

                    img {
                        transition: 0.2s;
                    }
                }

                .houses_list {
                    padding: 0 34px;

                    .house_item {
                        margin: 12px 0;
                        cursor: pointer;
                    }
                }
            }

            .active {
                .name {
                    img {
                        transform: rotate(180deg);
                    }
                }
            }
        }

        .add_house {
            width: 216px;
            margin: 0 auto;

            img {
                margin-left: 17px;
            }
        }
    }

    .content {
        width: 100%;
        display: flex;
        flex-direction: column;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .title {
                font-weight: 700;
                font-size: 30px;
                line-height: 41px;
                margin-top: 40px;
                margin-left: 36px;
            }

            .exit {
                width: 134px;
                height: 45px;
                border: 1px solid #CDCDCD;
                font-size: 16px;
                line-height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 38px;
                margin-right: 57px;
                cursor: pointer;
            }
        }

        .table_menu {
            display: flex;
            margin-top: 40px;
            padding-left: 35px;

            .inner {
                padding: 30px 45px;
                font-weight: 700;
                font-size: 16px;
                line-height: 20px;
                cursor: pointer;
            }

            .active {
                border-bottom: 3px solid #333333;
            }
        }

        .separator {
            width: 100%;
            height: 1px;
            background: #DFDFDF;
        }

        .flats {
            overflow-y: auto;

            table {
                width: 100%;

                tr {
                    td {
                        padding: 28px 40px;
                        text-align: center;

                        .delete_icon {
                            cursor: pointer;
                        }
                    }
                }

                .table_header {
                    td {
                        border-bottom: 1px solid #DFDFDF;
                    }
                }
            }
        }

        .info {
            overflow-y: auto;
            padding-left: 36px;
            padding-right: 55px;

            .address {
                display: flex;
                justify-content: space-between;
                width: 100%;
                margin-top: 44px;

                .inner {
                    display: flex;
                    align-items: center;

                    .title {
                        margin-right: 23px;
                        font-size: 14px;
                        line-height: 21px;
                    }

                    .value {
                        font-weight: 700;
                        font-size: 16px;
                        line-height: 24px;
                    }
                }
            }

            .head {
                font-size: 14px;
                line-height: 21px;
                margin-bottom: 28px;
                margin-top: 42px;
            }

            .intercoms {
                .intercom {
                    margin-bottom: 42px;

                    .separator {
                        margin-bottom: 36px;
                    }

                    .title {
                        margin-bottom: 26px;
                        display: flex;
                        justify-content: space-between;

                        .left {
                            display: flex;

                            img {
                                margin-left: 40px;
                                cursor: pointer;
                            }

                            .name {
                                font-weight: 700;
                                font-size: 20px;
                                line-height: 30px;
                            }
                        }

                        .right {
                            transform: scale(1.5);
                            cursor: pointer;
                            transition: 0.2s;
                        }
                    }

                    .main_info, .additional_info {
                        display: flex;

                        .left, .right {
                            width: 50%;

                            .inner {
                                margin-bottom: 19px;
                                display: flex;
                                align-items: center;

                                .name {
                                    width: 188px;
                                    font-size: 14px;
                                    line-height: 21px;
                                }

                                .value {
                                    font-weight: 700;
                                    font-size: 16px;
                                    line-height: 24px;
                                }
                            }
                        }
                    }

                    .main_info {
                        margin-bottom: 21px;
                    }
                }

                .active {
                    .title {
                        .right {
                            transform: rotate(180deg) scale(1.5);
                        }
                    }
                }
            }
        }

        .add_new {
            position: fixed;
            right: 57px;
            bottom: 40px;

            img {
                margin-left: 17px;
            }
        }

        .new_flat {
            width: 248px;
        }

        .new_intercom {
            width: 216px;
        }
    }
}
</style>